module.exports = __webpack_public_path__ + "media/images/webpage/hotels/743/plan3-2-d3e1254c445d1c12e67529687105da58.webp";